// organizations/users

import $api from "@/frontend/shared/api/axios";
import { TOrganizationUsers } from "../types/types";

export async function getUsersList(): Promise<TOrganizationUsers[]> {
  const response = await $api.get("/organizations/users");
  return response.data.data;
}
